import React from 'react';

const toStringDateTime = (field) => {
  return field.value && !field.isError ? new Date(field.value).toLocaleString() : field.inputValue
}

const ValidatedField = ({field, isDatetime}) => 
  <td 
    className={field.isError === true ? 'is-error' : ''}
    title={field.isError === true ? field.errorMessage : null}>
      {field.value}
      {field.isError === true ? <i className="error-message material-icons">warning</i> : null}
  </td>;

export default ValidatedField;




// WEBPACK FOOTER //
// ./App/components/modules/measurement-validator/errors-dialog/validated-field.js